import { render, staticRenderFns } from "./xeLiveTable.vue?vue&type=template&id=18d566b4"
import script from "./xeLiveTable.vue?vue&type=script&lang=js"
export * from "./xeLiveTable.vue?vue&type=script&lang=js"
import style0 from "./xeLiveTable.vue?vue&type=style&index=0&id=18d566b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports